import { render, staticRenderFns } from "./PropertiesSearchFilters.vue?vue&type=template&id=4b481c86"
import script from "./PropertiesSearchFilters.vue?vue&type=script&lang=js"
export * from "./PropertiesSearchFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports